import * as React from 'react';
import { Textarea, CheckSymbol } from 'ui';
import { FilterCommonProps, OptionType, SubOptionType } from './types';
import { getValue } from './get-value';
import { MeatballPanel } from 'app/area/search-filters/filters/meatball-panel';
import { SubOptionTypes } from 'app/components/filters/types';

type FilterExternalValuePropsType = string | Object;

export interface FilterExternalValueState {
  selectedSubOptions?: SubOptionTypes[];
}

export class FilterExternalValue extends React.PureComponent<FilterCommonProps<FilterExternalValuePropsType>, FilterExternalValueState> {

  constructor(props: FilterCommonProps<FilterExternalValuePropsType>) {
    super(props);

    this.state = {
      selectedSubOptions: []
    };
  }

  public componentDidUpdate(prevProps: FilterCommonProps<string>) {
    if (!this.props.values && !!prevProps?.values) {
      this.setDefaultSubOptionType();
    }
  }

  private setDefaultSubOptionType = () => this.setState({ selectedSubOptions: [] });

  private hasMatchExact = () => this.state.selectedSubOptions.some(type => type === SubOptionTypes.MatchExact);

  private onSubOptionTypeChange = (value: string, subOptionType: SubOptionType) =>
    this.props.onChange(this.props.id, [{
      optionType: OptionType.specified,
      subOptionType,
      value
    }].filter(v => !!v.value) || []);

  private onChangeText = (value: string) =>
    this.onSubOptionTypeChange(value, this.hasMatchExact() ? SubOptionType.matchExact : SubOptionType.text);

  private onChangeMatchExact = () => {
    const textValue = getValue(this.props.values, SubOptionType.text)?.value as string;
    const matchExactValue = getValue(this.props.values, SubOptionType.matchExact)?.value as string;
    const matchUnselectWithTextValue = !this.hasMatchExact() && (!!matchExactValue || !!textValue);

    this.onSubOptionTypeChange(
      textValue ?? matchExactValue,
      matchUnselectWithTextValue ? SubOptionType.text : SubOptionType.matchExact
    );
  };

  private handleSubOptionChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const value = Number(e.currentTarget.value);

    const selectedSubOption = e.currentTarget.checked && value;
    const newSubTypes = Number.isInteger(selectedSubOption) ? [...this.state.selectedSubOptions, selectedSubOption]
      : this.state.selectedSubOptions.filter(item => !selectedSubOption && item !== value);

    this.setState({
      selectedSubOptions: newSubTypes
    }, this.onChangeMatchExact);
  };

  public render() {
    const { id, values, translation } = this.props;
    const text = getValue(values, SubOptionType.text);
    const matchExact = getValue(values, SubOptionType.matchExact);

    return <>
      <MeatballPanel configuration={this.props.meatballPanelConfiguration} />
      <div className="form-check">
        <b className="pl-2">{translation.filters_contains_word}</b>
        <input
          id={`${id}-match-exact`}
          type="checkbox"
          className="form-check-input visuallyhidden"
          value={SubOptionTypes.MatchExact}
          checked={this.state.selectedSubOptions.some(type => type === SubOptionTypes.MatchExact)}
          onChange={this.handleSubOptionChange}
        />
        <label
          htmlFor={`${id}-match-exact`}
          className="form-check-label media mt-2">
          <CheckSymbol />
          {translation.filters_contains_word_exact}
        </label>
      </div>
      <Textarea
        className={undefined}
        componentId={`${id}_text`}
        value={text.value as any ?? matchExact.value as any}
        onChange={this.onChangeText}
        maxLength={254}
        wait={0}
        validation={undefined}
      />
    </>;
  }
}
